import { useDispatch } from 'react-redux';
import { withFormsy } from 'formsy-react';
import FuseLayoutConfigs from '@fuse/layouts/FuseLayoutConfigs';
import { MenuItem, styled } from '@mui/material';

import { updateUserSettings } from 'app/store/userSlice';
import BaseTextField, { type FieldProps } from '../components/BaseTextField';
import useSettings from '../../hooks/useSettings';
import Icon from '../../Icon';

type AppSettingsFieldProps = {
	/** The user's uid */
	userUid: string;
} & Omit<FieldProps<string>, 'startAdornment' | 'endAdornment'>;

const SelectTextField = styled(BaseTextField)(({ isEdit, theme }) => ({
	'& > .MuiInputBase-root > .MuiSelect-icon': {
		display: isEdit ? 'block' : 'none'
	}
}));

function LayoutSelectField({
	className,
	name,
	value,
	sendChange,
	isEdit,
	isFormSubmitted,
	isPristine,
	isValid
}: AppSettingsFieldProps) {
	const dispatch = useDispatch<any>();
	const { t } = useSettings();

	const handleChange = event => {
		if (event.target.value === 'default') sendChange(name, null);
		else {
			dispatch(updateUserSettings({ layout: event.target.value }));
			sendChange(name, event.target.value);
		}
	};

	return (
		<SelectTextField
			className={className}
			name={name}
			label={t('LAYOUT_FIELD')}
			select
			isEdit={isEdit}
			startAdornment={<Icon icon="view-quilt" />}
			value={value || 'default'}
			isFormSubmitted={isFormSubmitted}
			isPristine={isPristine}
			isValid={isValid}
			onChange={handleChange}
		>
			<MenuItem value="default">{t('DEFAULT_VALUE')}</MenuItem>
			{Object.entries(FuseLayoutConfigs).map(([key, layout]) => (
				<MenuItem key={key} value={key}>
					{layout.title}
				</MenuItem>
			))}
		</SelectTextField>
	);
}

export default withFormsy(LayoutSelectField);
